import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const DLP: React.FC = () => {
  const sections = [
    {
      title: 'Data Leakage Prevention (DLP)',
      content: 'Our DLP solutions protect your organization\'s sensitive data from unauthorized access, use, and transmission. We implement comprehensive data protection strategies that monitor, detect, and prevent data breaches across all channels including email, web, endpoints, and cloud applications.',
      benefits: [
        'Comprehensive data discovery and classification',
        'Real-time data monitoring and protection',
        'Policy-based data loss prevention',
        'Incident investigation and forensics',
        'Compliance reporting and audit support'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Data Leakage Prevention"
      subtitle="Comprehensive DLP solutions to protect sensitive data and prevent unauthorized access, use, and transmission."
      sections={sections}
    />
  );
};

export default DLP;

